// Theme: jade-terminal
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'jade-terminal',
  name: 'JADE TERMINAL',
  tagline: 'JADE TERMINAL',
  description: 'Terminal jade ancestral com gradiente vertical e foco tecnico.',
  category: 'fantasy-realms',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0A1A12', '#059669', '#0F2A1A', '#D1FAE5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)'
    },
    shellClasses: 'font-mono theme-jade-terminal'
  },
  colorVars: {
    '--accent': '#059669',
    '--accent-foreground': '#0A1A12',
    '--background': '#0A1A12',
    '--border': '#2A7A50',
    '--card': '#0F2A1A',
    '--card-border-active': 'rgba(5, 150, 105, 0.42)',
    '--card-completed': '#0F2A1A',
    '--card-foreground': '#D1FAE5',
    '--card-glow': 'rgba(5, 150, 105, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0A1A12',
    '--foreground': '#D1FAE5',
    '--hold-fill': '#059669',
    '--input': '#0F2A1A',
    '--modal-bg': '#0A1A12',
    '--modal-border': '#2A7A50',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A7A50',
    '--muted-foreground': '#D1FAE5',
    '--nav-active': '#059669',
    '--nav-bg': '#0A1A12',
    '--popover': '#0F2A1A',
    '--popover-foreground': '#D1FAE5',
    '--primary': '#059669',
    '--primary-foreground': '#0A1A12',
    '--ring': '#059669',
    '--secondary': '#2A7A50',
    '--secondary-foreground': '#D1FAE5',
    '--streak': '#059669',
    '--success': '#22C55E',
    '--success-foreground': '#0A1A12',
    '--xp': '#059669',
    '--xp-bg': '#0F2A1A'
  },
  resolvedVars: {
    '--accent': '#059669',
    '--accent-foreground': '#0A1A12',
    '--accent-foreground-hsl': '150 44% 7%',
    '--accent-foreground-oklch': 'from #0A1A12 l c h',
    '--accent-hsl': '161 94% 30%',
    '--accent-oklch': 'from #059669 l c h',
    '--background': '#0A1A12',
    '--background-hsl': '150 44% 7%',
    '--background-oklch': 'from #0A1A12 l c h',
    '--border': '#2A7A50',
    '--border-hsl': '149 49% 32%',
    '--border-oklch': 'from #2A7A50 l c h',
    '--border-w': '1px',
    '--card': '#0F2A1A',
    '--card-border-active': 'rgba(5, 150, 105, 0.42)',
    '--card-completed': '#0F2A1A',
    '--card-completed-hsl': '144 47% 11%',
    '--card-completed-oklch': 'from #0F2A1A l c h',
    '--card-foreground': '#D1FAE5',
    '--card-foreground-hsl': '149 80% 90%',
    '--card-foreground-oklch': 'from #D1FAE5 l c h',
    '--card-glow': 'rgba(5, 150, 105, 0.08)',
    '--card-hsl': '144 47% 11%',
    '--card-oklch': 'from #0F2A1A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0A1A12',
    '--destructive-foreground-hsl': '150 44% 7%',
    '--destructive-foreground-oklch': 'from #0A1A12 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#D1FAE5',
    '--foreground-hsl': '149 80% 90%',
    '--foreground-oklch': 'from #D1FAE5 l c h',
    '--hold-fill': '#059669',
    '--hold-fill-hsl': '161 94% 30%',
    '--hold-fill-oklch': 'from #059669 l c h',
    '--input': '#0F2A1A',
    '--input-hsl': '144 47% 11%',
    '--input-oklch': 'from #0F2A1A l c h',
    '--modal-bg': '#0A1A12',
    '--modal-bg-hsl': '150 44% 7%',
    '--modal-bg-oklch': 'from #0A1A12 l c h',
    '--modal-border': '#2A7A50',
    '--modal-border-hsl': '149 49% 32%',
    '--modal-border-oklch': 'from #2A7A50 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A7A50',
    '--muted-foreground': '#D1FAE5',
    '--muted-foreground-hsl': '149 80% 90%',
    '--muted-foreground-oklch': 'from #D1FAE5 l c h',
    '--muted-hsl': '149 49% 32%',
    '--muted-oklch': 'from #2A7A50 l c h',
    '--nav-active': '#059669',
    '--nav-active-hsl': '161 94% 30%',
    '--nav-active-oklch': 'from #059669 l c h',
    '--nav-bg': '#0A1A12',
    '--nav-bg-hsl': '150 44% 7%',
    '--nav-bg-oklch': 'from #0A1A12 l c h',
    '--popover': '#0F2A1A',
    '--popover-foreground': '#D1FAE5',
    '--popover-foreground-hsl': '149 80% 90%',
    '--popover-foreground-oklch': 'from #D1FAE5 l c h',
    '--popover-hsl': '144 47% 11%',
    '--popover-oklch': 'from #0F2A1A l c h',
    '--primary': '#059669',
    '--primary-foreground': '#0A1A12',
    '--primary-foreground-hsl': '150 44% 7%',
    '--primary-foreground-oklch': 'from #0A1A12 l c h',
    '--primary-hsl': '161 94% 30%',
    '--primary-oklch': 'from #059669 l c h',
    '--radius': '12px',
    '--ring': '#059669',
    '--ring-hsl': '161 94% 30%',
    '--ring-oklch': 'from #059669 l c h',
    '--secondary': '#2A7A50',
    '--secondary-foreground': '#D1FAE5',
    '--secondary-foreground-hsl': '149 80% 90%',
    '--secondary-foreground-oklch': 'from #D1FAE5 l c h',
    '--secondary-hsl': '149 49% 32%',
    '--secondary-oklch': 'from #2A7A50 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 8%, transparent)',
    '--streak': '#059669',
    '--streak-hsl': '161 94% 30%',
    '--streak-oklch': 'from #059669 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0A1A12',
    '--success-foreground-hsl': '150 44% 7%',
    '--success-foreground-oklch': 'from #0A1A12 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(161 94% 30% / 0.15)',
    '--xp': '#059669',
    '--xp-bg': '#0F2A1A',
    '--xp-bg-hsl': '144 47% 11%',
    '--xp-bg-oklch': 'from #0F2A1A l c h',
    '--xp-hsl': '161 94% 30%',
    '--xp-oklch': 'from #059669 l c h'
  }
}
